export const tool = {
  /**鼠标点击延迟，name：节点的类名，delay:延迟时间（ms） */
  clickDelay: (name, delay = 1200) => {
    let nodeArr;

    nodeArr = document.getElementsByClassName(name);

    if (!nodeArr || nodeArr.length <= 0) {
      console.warn("鼠标点击延迟添加失败，节点不存在！！！！请查看----->");

      return;
    }

    for (let i = 0; i < nodeArr.length; i++) {
      let node = nodeArr[i];

      node.style.pointerEvents = "none";

      setTimeout(() => {
        if (node) node.style.pointerEvents = "";
      }, delay);
    }
  },
   /**

  * 格式化时间 format Time - type 01

  * @param {Number} time

  */

    formatTime: (time, type = "") => {

      time = parseInt(time);
  
      if (!time) return null;
  
      const yy = new Date(time).getFullYear();
  
      const mm = new Date(time).getMonth() + 1;
  
      const dd = new Date(time).getDate();
  
      let t2 = new Date(time).getHours() + ""; //获取时
  
      let t3 = new Date(time).getMinutes() + ""; //获取分
  
      let t1;
  
      if (type === "s") {
  
        t1 = `${yy}年${mm}月${dd}日${t2}时${t3}秒`;
  
      } else if (type === "h") {
  
        t1 = `${yy}年${mm}月${dd}日${t2}时`;
  
      } else {
  
        t1 = `${yy}年${mm}月${dd}日`;
  
      }
  
      // console.log(new Date(time).toLocaleDateString())
  
      // const t1 = new Date(time).toLocaleDateString() + ''//获取年月日
  
      // const t4 = new Date(time).getMilliseconds() + ''//获取秒
  
      // if (parseInt(t2) < 10) t2 = '0'+t2
  
      // if (parseInt(t3) < 10) t3 = '0'+t3
  
      // time = t1 + ' ' + t2 + ':' + t3
  
      time = t1;
  
      // console.log('time', time, t1 + ' ' + t2 + ':' + t3)
  
      return time;
  
    },
};
